import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202507: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202507",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-07-01",
  endDate: "2025-07-31",
  impressions: 5762,
  clicks: 122,
  adsSpendDollars: 403,
  budgetDollars: 1500,
  salesDollars: 7303,
  bestEstimateRoas: 18.12,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.27,
  newCustomersAcquired: 7,
  dataAvailableAtDate: "2025-08-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
